"use client";

import { useMemo } from "react";
import { countActiveManualUserTasksFromPage } from "@/lib/user-tasks/count-active-user-tasks";
import { useUserTasksGet } from "./useUserTasksGet";

/** Sidebar / nav badge count: only Open and In progress (API `active=true`). */
export function useActiveUserTasksCount(enabled: boolean) {
  const { data, isPending } = useUserTasksGet({
    activeOnly: true,
    pageSize: 100,
    enabled,
  });

  const count = useMemo(() => countActiveManualUserTasksFromPage(data), [data]);

  return { count, isPending };
}
